import CreateNewDocCard from "./CreateNewDocCard";

export default CreateNewDocCard;



// WEBPACK FOOTER //
// ./src/components/PipelineWrapper/CreateNewDocCard/index.js